import axios, { AxiosRequestConfig } from 'axios';
import SafeUtil from './SafeUtil';

function getCookieValue(name: string): string {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

//http请求全部收口在这个工具类中，可以快速切换http框架。
export default class HttpUtil {
  static httpGet(
    url: any,
    params = {},
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any,
    opts?: any
  ) {
    // ============ 修复：使用 opts 配置 ============
    const sessionId = getCookieValue('_ak');
    const config: AxiosRequestConfig = {
      params: params,
      withCredentials: true, // 确保携带 Cookie
      headers: { 'X-Session-Id': sessionId },
      ...opts // 合并传入的配置
    };

    axios
      .get(url, config)
      .then(function (response) {
        SafeUtil.safeCallback(successCallback)(response);
      })
      .catch(function (error) {
        SafeUtil.safeCallback(errorCallback)(error);
      })
      .finally(function () {
        SafeUtil.safeCallback(finallyCallback)();
      });
  }

  static httpPost(
    url: any,
    params = {},
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any,
    opts?: any
  ) {
    // ============ 修复：确保配置正确 ============
    const sessionId = getCookieValue('_ak');
    const config: AxiosRequestConfig = {
      withCredentials: true, // 确保携带 Cookie
      headers: { 'X-Session-Id': sessionId },
      ...opts // 合并传入的配置
    };

    // 如果 opts 中没有设置 Content-Type，设置默认值
    if (!config.headers?.['Content-Type']) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }

    return axios
      .post(url, params, config)
      .then(function (response) {
        SafeUtil.safeCallback(successCallback)(response);
      })
      .catch(function (error) {
        SafeUtil.safeCallback(errorCallback)(error);
      })
      .finally(function () {
        SafeUtil.safeCallback(finallyCallback)();
      });
  }

  /**
   * 上传文件的请求
   */
  static httpPostFile(
    url: string,
    formData: FormData,
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any,
    processCallback?: (progressEvent: any) => void,
    opts?: any
  ) {
    const sessionId = getCookieValue('_ak');
    const config: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Session-Id': sessionId,
        ...opts?.headers // 合并传入的 headers
      },
      withCredentials: true, // 确保携带 Cookie
      cancelToken: opts ? opts.cancelToken : undefined,
      onUploadProgress: processCallback,
      ...opts // 合并其他配置
    };

    axios
      .post(url, formData, config)
      .then(function (response) {
        SafeUtil.safeCallback(successCallback)(response);
      })
      .catch(function (error) {
        SafeUtil.safeCallback(errorCallback)(error);
      })
      .finally(function () {
        SafeUtil.safeCallback(finallyCallback)();
      });
  }
}